import React, { useState, useEffect } from "react";
import { Grid, TextField, Dialog, Typography } from "@material-ui/core";

import CardBody from "../../../components/Card/CardBody";
import Button from "../../../components/CustomButtons/Button";
import PropTypes from "prop-types";

import { reminderUpdate } from "../../../actions";
import { connect } from "react-redux";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: "block",
    boxSizing: "border-box",
    width: "100%",
    borderRadius: "4px",
    border: "1px solid black",
    padding: "14px 15px",
    marginTop: "9px",
    fontSize: "14px",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditReminder = (props) => {
  const {
    onClose,
    open,
    reminderUpdate,
    reminderById,
    IncCount,
    reminderId,
  } = props;
  const [startDate, setStartDate] = useState("");
  const [reminderText, setReminderText] = useState("");

  const classes = useStyles();

  const CustomInput = React.forwardRef((props, ref) => {
    return (
      <input
        onClick={props.onClick}
        value={props.value}
        className={classes.input}
        type="text"
        placeholder="Select Start Date Time "
        readOnly={true}
      />
    );
  });

  useEffect(() => {
    console.log(reminderById);
    if (reminderById.attributes !== undefined) {
      setReminderText(reminderById.attributes.reminder_text);

      setStartDate(moment(reminderById.attributes.reminder_datetime).toDate());
      console.log(reminderById.attributes.reminder_text);
      console.log(moment(reminderById.attributes.reminder_datetime).toDate());
    }
  }, [reminderById]);

  const handleReminderText = (value) => {
    setReminderText(value);
  };

  const handleStartDate = (value) => {
    setStartDate(value);
    console.log(value);
  };

  const handleSubmit = () => {
    let date = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
    let newStartDate = new Date(date).toISOString();

    const doctor_reminder = {
      reminder_text: reminderText,
      reminder_datetime: newStartDate,
    };
    reminderUpdate(doctor_reminder, reminderId);
    IncCount();
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      TransitionComponent={Transition}
      open={open}
      fullWidth={true}
      maxWidth={"md"}
    >
      <div className={classes.root1}>
        <div className={classes.header}>
          <Typography
            align="center"
            gutterBottom
            variant="h5"
            style={{ color: "blue" }}
          >
            Edit Reminder
          </Typography>
        </div>
        <CardBody>
          <Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3} md={3}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Reminder"
                    name="reminder_text"
                    onChange={(e) => handleReminderText(e.target.value)}
                    value={reminderText || ""}
                    multiline
                    rows={4}
                    // defaultValue=""
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  <ReactDatePicker
                    valueName="selected" // DateSelect value's name is selected
                    onChange={(date) => handleStartDate(date)}
                    selected={startDate}
                    name="start_datetime"
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={1}
                    timeCaption="time"
                    dateFormat="yyyy-MM-dd HH:mm "
                    minDate={moment().toDate()}
                    isClearable
                    customInput={<CustomInput />}
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      flip: {
                        // enabled: false,
                      },
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Button
                    onClick={handleSubmit}
                    style={{
                      width: 72,
                      marginTop: 12,
                      backgroundColor: "rgb(50, 123, 175)",
                    }}
                  >
                    Submit
                  </Button>
                  <Button
                    onClick={onClose}
                    style={{
                      width: 72,
                      marginTop: 12,
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardBody>
      </div>
    </Dialog>
  );
};

EditReminder.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    reminderById: state.reminder.reminderById,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reminderUpdate: (doctor_reminder, id) =>
      dispatch(reminderUpdate(doctor_reminder, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditReminder);
